import { Stack, Text, Title, useMantineTheme } from '@mantine/core'
import React from 'react'

interface TemplatePropertyProps {
  title: string
  description?: string
  subtitle?: string
  children: React.ReactNode
}

const TemplateProperty: React.FC<TemplatePropertyProps> = ({
  title,
  description,
  subtitle,
  children,
}) => {
  const theme = useMantineTheme()

  return (
    <Stack style={{ margin: '20px 2px', gap: '15px' }}>
      <Stack style={{ gap: '3px' }}>
        <Stack style={{ gap: '10px', flexDirection: 'row', alignItems: 'center' }}>
          <Title order={5}>{title}</Title>
        </Stack>
        {description && (
          <Text style={{ textAlign: 'left', color: theme.colors.paragraph[0], fontSize: '12px' }}>
            {description}
          </Text>
        )}
        {subtitle && (
          <Text style={{ textAlign: 'left', color: theme.colors.paragraph[0], fontSize: '12px' }}>
            {subtitle}
          </Text>
        )}
      </Stack>
      {children}
    </Stack>
  )
}

export default TemplateProperty
